{
    "press": {
        "title": "Press Room",
        "contact": "For press opportunities please email <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a>",
        "material": "Press Material",
        "read_article": "Read article",
        "open_link": "Open link",
        "download": "Download",
        "load_more_articles": "Load more articles",
        "load_more_materials": "Load more material",
        "no_articles": "More content in the making. Check back soon!",
        "no_materials": "More content in the making. Check back soon!",
        "article_not_found": "Content not available in Spanish",
        "article_not_found_description": "<a class=\"{variant}\" href=\"{link}\">Click here</a> to go back to our Press page in English or Email us at <a class=\"{emailVariant}\" href=\"mailto:{email}\">{email}</a> for press opportunities"
    }
}